import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { Route } from 'router/Route';

import { L10nContext } from 'context/L10nContext';

import { ModalNotification } from 'presentation/ui/components/modal-notification/ModalNotification';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonPrimary } from 'presentation/ui/partials/button/button-primary/ButtonPrimary';
import { ModalNotificationLevel } from 'presentation/ui/components/modal-notification/ModalNotificationLevel';
import { CyclotronProductViewModel } from 'services/nuclide/domain/model/CyclotronProductModel';

export interface CyclotronProductCreateSuccessNotificationProps {
	/**
	 * Handle click confirm
	 */
	onClickConfirm: () => void;
	/**
	 * Created cyclotron product
	 */
	cyclotronProductCreated?: CyclotronProductViewModel;
}

export const CyclotronProductCreateSuccessNotification = (props: CyclotronProductCreateSuccessNotificationProps): JSX.Element => {
	const { onClickConfirm, cyclotronProductCreated } = props;

	// Consume context
	const l10nContext = useContext(L10nContext);

	// Consume the history object
	const history = useHistory();

	return (
		<>
			<ModalNotification
				caption={l10nContext.translate('common.modal.successCaption', 'Abgeschlossen')}
				message={l10nContext.translate('view.cyclotronProducts.modal.action.create.successMessage', 'Das Radionuklid wurde erfolgreich angelegt')}
				level={ModalNotificationLevel.LEVEL_SUCCESS}
			/>
			<ColumnLayout mode={ColumnLayoutMode.ALIGN_CENTER}>
				<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
					<ButtonPrimary
						buttonText={l10nContext.translate('view.cyclotronProducts.btnCyclotronDetails', 'Weiter zu den Details des Radionuklids')}
						onClick={() => { history.push(Route.NUCLIDE_MANAGEMENT + Route.CYCLOTRON_PRODUCTS + '/' + cyclotronProductCreated.Uuid); }}
					/>
				</ColumnLayoutSection>
				<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
					<ButtonPrimary
						buttonText={l10nContext.translate('view.cyclotronProducts.btnCyclotronOverview', 'Weiter zur Übersicht der Radionuklide')}
						onClick={onClickConfirm}
					/>
				</ColumnLayoutSection>
			</ColumnLayout>
		</>
	);
};
